import reset from "styled-reset";
import { createGlobalStyle, css } from "styled-components";

interface Props {
  os: "ios" | "android";
}
const GlobalStyle = createGlobalStyle<Props>` 
@font-face {
  font-family: NotoSans;
  font-weight: 400;
  src: url(${require("./fonts/NotoSans-Regular.otf")}) format("truetype");
}
@font-face {
  font-family: NotoSans;
  font-weight: 500;
  src: url(${require("./fonts/NotoSans-Medium.otf")}) format("truetype");
}
@font-face {
  font-family: NotoSans;
  font-weight: 700;
  src: url(${require("./fonts/NotoSans-Bold.otf")}) format("truetype");
}

  ${reset};
  * {
    box-sizing: border-box;

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    
    ::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera*/
    }
  }
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, sub, sup, tt, var,
  u, i, center, dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video , button, input,
  select, textarea {
    word-break: break-all;
    ${(props) => {
      if (props.os === "android") {
        return css`
          font-family: NotoSans, Roboto, Helvetica, Arial, sans-serif;
        `;
      } else {
        return css`
          font-family: SF Display Pro, Helvetica Neue, Helvetica, Arial,
            Sans-Serif;
        `;
      }
    }};
  }
  html {
    height:100%
  }
  body {
    color: #fff;
    background: #1f2126;
    -webkit-user-select: none;
    height:100%
  }
  a {
      color: inherit;
      text-decoration: none;
  }
  input,
  button {
      &:focus,
      &:active{ outline: none }
  }
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }
  input::-ms-clear,
  input::-ms-reveal{
    display:none;width:0;height:0;
  }
  input::-webkit-search-decoration,
  input::-webkit-search-cancel-button,
  input::-webkit-search-results-button,
  input::-webkit-search-results-decoration{
    display:none;
  }
  strong {
    font-weight: 500;
  }
  b {
    font-weight: bold;
  }
  input,
  textarea {
    -webkit-user-select: auto;
  }
  #root {
    height:100%
  }
`;

export default GlobalStyle;
